import React from 'react';
import SectionHeader from './ui/SectionHeader';

const About = () => {
  const expertise = [
    {
      code: '01',
      title: 'HSE management',
      description: 'Risk assessment, hazard identification (HIRARC and JSA), accident investigation, and safety management systems.',
    },
    {
      code: '02',
      title: 'Site work',
      description: 'Construction and marine safety, onshore drilling, and Permit-to-Work on the rig.',
    },
    {
      code: '03',
      title: 'Standards',
      description: 'Working knowledge of ISO 9001, ISO 14001, ISO 45001, and SMK3, plus CSMS and UKL-UPL.',
    },
    {
      code: '04',
      title: 'Credentials',
      description: 'AK3 Umum, Operator K3 Migas, Authorized Gas Tester, and First Aider. The NEBOSH IGC certificate is not yet issued.',
    },
  ];

  const stats = [
    { value: '9', label: 'Years' },
    { value: '7', label: 'Credentials' },
    { value: '9', label: 'Projects' },
  ];

  const standards = [
    { name: 'ISO 9001', note: 'Awareness' },
    { name: 'ISO 14001', note: 'Awareness' },
    { name: 'ISO 45001', note: 'Awareness' },
    { name: 'SMK3', note: 'Awareness' },
    { name: 'K3 Migas', note: 'Operator' },
    { name: 'AGT', note: 'Apr 2026' },
    { name: 'First Aider', note: 'May 2026' },
    { name: 'NEBOSH IGC', note: 'Not issued' },
  ];

  return (
    <section id="about" className="section-rule bg-btc-surface">
      <div className="container-max section-padding py-24">
        <SectionHeader
          number="02"
          label="System"
          title="About"
          kicker="HSE work in oil and gas drilling and large construction since September 2017."
        />

        <div className="grid gap-6 lg:grid-cols-12">
          <div className="surface-card p-8 md:p-12 lg:col-span-7">
            <p className="text-lg leading-relaxed text-white md:text-xl">
              HSE officer since September 2017, on drilling rigs, marine construction,
              port development, dredging, and coal power plants. The sites include the
              1,500 HP PDSI #09.2/N80UE onshore rig, Patimban Port, and PLTU Batang 2x1000 MW.
            </p>
            <p className="mt-6 leading-relaxed text-btc-muted">
              Recent work covered HIRARC and Job Safety Analysis, permit to work, site
              inspection, and safety inductions and toolbox talks. Available for the next HSE role.
            </p>
            <p className="mt-6 leading-relaxed text-btc-muted">
              Working knowledge of ISO 9001, ISO 14001, ISO 45001, and SMK3, from an
              awareness course in January 2022. Holds AK3 Umum, Operator K3 Migas,
              Authorized Gas Tester, and First Aider. The NEBOSH IGC certificate is not yet issued.
            </p>
          </div>

          <div className="grid gap-4 lg:col-span-5">
            {expertise.map((item) => (
              <article key={item.code} className="lift-card p-6">
                <p className="label">{item.code}</p>
                <h3 className="mt-3 font-heading text-lg font-semibold text-white">
                  {item.title}
                </h3>
                <p className="mt-2 text-sm leading-relaxed text-btc-muted">
                  {item.description}
                </p>
              </article>
            ))}
          </div>
        </div>

        <div className="mt-6 grid grid-cols-1 gap-4 sm:grid-cols-3">
          {stats.map((stat) => (
            <div key={stat.label} className="surface-card p-8">
              <p className="text-gold font-mono text-6xl font-medium md:text-7xl">
                {stat.value}
              </p>
              <p className="label mt-3">{stat.label}</p>
            </div>
          ))}
        </div>

        <div className="mt-6 grid grid-cols-2 gap-3 sm:grid-cols-4">
          {standards.map((standard) => (
            <div key={standard.name} className="lift-card flex min-h-[88px] flex-col justify-center p-4">
              <p className="label">{standard.note}</p>
              <p className="mt-1 font-heading font-semibold text-white">{standard.name}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default About;
